/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.row.bg-danger[_ngcontent-%COMP%]{background-color:rgba(179,35,23,.15)!important}.row.bg-success[_ngcontent-%COMP%]{background-color:rgba(52,124,23,.15)!important}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL2NvbXBvbmVudHMtdjEvZGVhbGVyYmxvY2staXRlbS12MS9kZWFsZXJibG9jay1pdGVtLXYxLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL2NvbXBvbmVudHMtdjEvZGVhbGVyYmxvY2staXRlbS12MS9kZWFsZXJibG9jay1pdGVtLXYxLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/node_modules/@nw/ui-watchlist/components/components-v1/dealerblock-item-v1/dealerblock-item-v1.component.scss.shim.ngstyle.ts